import MessageList from './MessageList';

export default MessageList;
